import {Navigate, Route, Routes} from "react-router-dom"
import LoginPage from "../pages/LoginPage";
import {useAuth} from "../context/useAuth";
import {PrivateRoutes} from "./PrivateRoutes";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";


export const AppRouter = () => {
    const { isLoggedIn } = useAuth();

    return (
        <Routes>
            {
                isLoggedIn()
                    ? <Route path="/*" element={<PrivateRoutes />} />
                    : <>
                        <Route path="login" element={<LoginPage />} />
                        <Route path="forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="reset-password" element={<ResetPasswordPage />} />
                    </>
            }
            <Route path='*' element={<Navigate to='/login' replace />} />
        </Routes>
    )
}